export const createPaymentIntent = async (
  amount: number,   // dollars
  goalId: string,
  type: 'gift' | 'investment',
  meta?: { contributorId?: string; email?: string; name?: string; campaignTitle?: string }
) => {
  const response = await fetch('/api/create-payment-intent', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ amount: Math.round(amount * 100), goalId, type, ...meta }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to create payment intent');
  }
  return response.json() as Promise<{ clientSecret: string }>;
};
